import type { Action, Dispatch, TypedStartListening } from '@reduxjs/toolkit';

import { type AUTH_REDUCER_KEY, authActions } from '../../flux/auth';
import { clearReceiptSplitSuggestionCache } from '../../flux/receipts/receiptSplitSuggestionCache';
import type RootState from '../../utils/redux-store/rootState';

type RequiredState = Pick<RootState, typeof AUTH_REDUCER_KEY>;
type AppStartListening = TypedStartListening<RequiredState, Dispatch<Action>>;

export const setupReceiptSessionInvalidationListener = (
  startAppListening: AppStartListening,
  invalidate: () => void,
): void => {
  startAppListening({
    predicate: (action) =>
      action.type === authActions.authLogout.type || action.type === authActions.authSelectDataset.type,
    effect: () => {
      clearReceiptSplitSuggestionCache();
      invalidate();
    },
  });
};
